export default __webpack_public_path__ + "static/media/smartGatingBorder.6f2585d0.svg";